import axios from 'axios';

/**
 * Fire a fire-and-forget log event for the 3DS form lifecycle.
 * Never throws or blocks the payment flow.
 *
 * @param {Object} params
 * @param {string} params.lyriaUrl       - Base URL of the Lyria API
 * @param {string} params.paymentRequestId - UUID of the payment request
 * @param {string} params.formApiUrl     - ACS URL the 3DS form was submitted to
 * @param {string} params.eventType      - One of: submitted, iframe_loaded, timeout, js_error, acs_page_redirect, acs_iframe_redirect, iframe_redirected
 * @param {number} [params.elapsedMs]    - Milliseconds since form submit (for iframe_loaded, timeout, iframe_redirected)
 * @param {string} [params.errorMessage] - Error message (for js_error)
 * @param {string} [params.jsStackTrace] - Stack trace (for js_error)
 */
export const log3DSFormEvent = ({ lyriaUrl, paymentRequestId, formApiUrl, eventType, elapsedMs, errorMessage, jsStackTrace }) => {
    try {
        axios.post(`${lyriaUrl}/payments/3ds-form-logs/`, {
            payment_request_id: paymentRequestId,
            form_api_url: formApiUrl,
            event_type: eventType,
            elapsed_ms: elapsedMs ?? null,
            error_message: errorMessage ?? null,
            js_stack_trace: jsStackTrace ?? null,
        }).catch(() => {});
    } catch (ignoreError) { /* fire-and-forget: never propagate */ }
};
